export const fillString = (character, len) => {
  let str = ''

  while (str.length < len) {
    str += character
  }

  return str.slice(0, len)
}
